import React from 'react'
import PropTypes from 'prop-types'

import {
  ITEM_TYPE_MAIL,
  ITEM_TYPE_RESPONDER,
} from '@client/components/Editor/settings'

const styles = {
  display: 'none', 
  fontSize: '0px', 
  lineHeight: '0px', 
  maxHeight: '0px', 
  maxWidth: '0px', 
  opacity: 0, 
  overflow: 'hidden', 
  visibility: 'hidden', 
  msoHide: 'all',
}

const PreHeader = ({ kind = '', preHeader = '', serverRender = false }) => {
  if (
    !(
      kind === ITEM_TYPE_MAIL ||
      kind === ITEM_TYPE_RESPONDER
    ) ||
    !preHeader
  ) {
    return null
  }
  const preHeaderText = serverRender ? '##pre_header##' : preHeader

  return (
    <div data-testid="pre_header" style={styles}>
      <div style={styles}>{preHeaderText}</div>
      <div style={styles}
        dangerouslySetInnerHTML={{
          __html: '&zwnj; &nbsp; '.repeat(128),
        }}
      />
    </div>
  )
}

PreHeader.propTypes = {
  kind: PropTypes.string,
  preHeader: PropTypes.string,
  serverRender: PropTypes.bool,
}

export default PreHeader
